import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import Rolling from './Rolling';
import IconGrid from "./IconGrid";
import StaticLatestUpdate from "./StaticLatestUpdate"

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};



	return (
		<div>
			{/* <Live /> */}
			{/* <Popup /> */}
			{/* <div className="row slider" style={{backgroundImage:'url(./images/spst-pl.jpg)',backgroundSize:'cover',backgroundPosition:'center',display:'flex',alignItems:'end',justifyContent:'center'}}>
		
		<div style={{width:'800px'}}>
			<img src="./images/spst-home-icon.png" alt="logo" className="homeimage" style={{width:'100%'}} />
		</div>
	</div> */}

			{/* Video Slider
	<div className="video-container">
      <video
        className="background-video"
        autoPlay
        loop
        muted
        playsInline
		style={{width:'100%',height:'100%'}}
      >
        <source src="./images/spst.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
</div> */}



			{/* <Popup /> */}
			{/* <Live /> */}
			{/* <!-- Sections --> */}
			{/* <Popup /> */}
			<Slider />
			{/* <img src="./images/pic-1.jpeg" alt="image" style={{width:'100%'} }/> */}
			<Rolling />

			{/* <div style={{width:'100%'}}>
			<img src="./images/pic-3.jpeg" style={{width:'100%'}} /> <br />
			<img src="./images/pic-6.jpeg" style={{width:'100%'}} />
		</div> */}

			{/* <div style={{width:'auto',marginLeft:'auto',marginRight:'auto',borderBottom:'1px solid maroon',padding:'20px'}}>
						<p className="cloak" style={{textAlign:'center',fontSize:'12pt',fontWeight:'700',color:'black'}}>Temple Cloak Room Timings | Morning: 03:30 am to 02:00 pm & Evening: 03:30 pm to 09:00 pm</p>
					</div> */}

			<div className="container" style={{ marginTop: '100px', marginBottom: '80px' }}>
				<Booking />
			</div>
			<div className="container" style={{ marginTop: '100px', marginBottom: '80px' }}>
				<div className="row">
					<div className="col-md-8" style={{ border: '1px solid silver', borderRadius: '10px', boxShadow: '0px 0px 10px silver inset' }}>
					<Rightside />
				</div>
				<div className="col-md-4">
					<StaticLatestUpdate />
				</div>
				</div>
				
			</div>
			<div className="container">
				<IconGrid />
			</div>
			<div className="container">
				<div className="row" style={{ background: 'maroon_', backgroundAttachment: 'fixed', padding: '20px', paddingTop: '50px' }}>
					<div className="col-md-6">

						{/* <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}}><img src="./images/popup.jpeg" alt="SPST " style={{ width: '100%' }} /></div> */}
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}><img src="./images/eve_1.jpeg" alt="SPST " style={{ width: '100%' }} /></div>
						{/* <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}}><img src="./images/eve_2.jpeg" alt="SPST " style={{ width: '100%' }} /></div> */}

						{/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}><img src="./images/eve_5.jpeg" alt="SPST " style={{ width: '100%' }} /></div> */}
					</div>
					<div className="col-md-6">
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}><img src="./images/eve_3.jpeg" alt="SPST " style={{ width: '100%' }} /></div>
					</div>

					<div className="container">

					</div>


				</div>
			</div>


			<div class="grouped_sections" style={{ backgroundImage: 'url(./images/spst.webp)', backgroundSize: 'cover', backgroundAttachment: 'fixed', backgroundPosition: 'center' }}>

				<div class="container">
					<div class="row">

						{/* <!-- Why Choose Us --> */}

						<div class="col-lg-12 grouped_col" style={{ background: 'rgba(18, 18, 18, 0.67)', padding: '35px' }}>
							<div class="grouped_title" style={{ color: 'white', fontWeight: '300' }}>
								<h2 className="tenders" style={{ paddingLeft: '20px', marginTop: '25px', borderBottom: '1px solid orange',color:'orange' }}>
									Dress code Guidelines for Darsan
								</h2>
							</div>
							<div className="row">
								<div className="col-md-6">
									<div class="menwomen">
										<img src="./images/men.png" style={{width:'100%',borderRadius:'25px'}} />
										<h4 class="" style={{textAlign:'center !important',fontSize:'16pt',fontWeight:'600',marginTop:'10px',marginBottom:'20px'}}>Dress code for men</h4>
										<ul style={{color:'black',listStyle:'circle',paddingLeft:'15px',fontSize:'11.7pt',fontWeight:'600'}}>
											<li>Traditional Kerala Mundu and Veshti (Upper Cloth) mandatory for all men entering the temple</li>
											<li style={{color:'maroon'}}>Trousers, Shorts, and Shirts must be left at the locker counter</li>
										</ul>
									</div>
								</div>
								<div className="col-md-6">
									<div class="menwomen">
										<img src="./images/women.png" style={{width:'100%',borderRadius:'25px'}} />
										<h4 class="" style={{textAlign:'center !important',fontSize:'16pt',fontWeight:'600',marginTop:'10px',marginBottom:'20px'}}>Dress code for Women</h4>
										<ul style={{color:'black',listStyle:'circle',paddingLeft:'15px',fontSize:'11.7pt',fontWeight:'600'}}>
											<li>Saree, Half-Saree (Pattu Pavadai with Blouse)</li>
											<li style={{color:'maroon'}}>Modern clothing like Trousers or Short dresses are not permitted</li>
										</ul>
									</div>
								</div>

							</div>

							<div class="grouped_title" style={{ color: 'white', fontWeight: '300',background:'maroon',paddingTop:'5px' }}>
								<h2 className="tenders" style={{ paddingLeft: '20px', marginTop: '25px', borderBottom: '1px solid orange',color:'orange',fontSize:'15pt' }}>
									Strictly mandatory for all pilgrims for daily darsan and special sevas. <br />
									We strictly adhere to ancient Kerala Temple traditions.
								</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
			

			<div class="container" style={{ paddingTop: '75px', paddingBottom: '75px' }}>
				<div class="row">
					<div class="col-md-5">
						<div className="fund">
							<img src="./images/suvarnadarsan.png" alt="Suvarna Darsanam" style={{ width: '100%', borderRadius: '15px' }} />
							{/* <center><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=75" className="btn btn-primary" style={{width:'150px',background:'orange',color:'maroon',border:'none',fontSize:'14pt',fontWeight:'700',marginTop:'15px'}}>Book </Link></center> */}
						</div>
					</div>
					<div class="col-md-7">
						<div className="fund">
							<img src="./images/bhadratha.png" alt="Suvarna Darsanam" style={{ width: '100%', borderRadius: '15px' }} />
							<center><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=72" className="btn btn-primary" style={{ width: '150px', background: 'orange', color: 'maroon', border: 'none', fontSize: '14pt', fontWeight: '700', marginTop: '15px' }}>Book </Link></center>
						</div>
					</div>
				</div>
			</div>
			<div className="gosala">
				<div className="overlay">
					<div class="gosaladonate">
						<Link to="https://booking.sreepadmanabhaswamytemple.org/Murajepam.aspx" className="btn btn-primary" style={{ padding: '20px', background: 'orange', color: 'maroon', fontSize: '14pt', fontWeight: '400', border: '1px solid orange' }}>Goshala Donation</Link>
						<Link to="https://booking.sreepadmanabhaswamytemple.org/GoldenGrace.aspx" className="btn btn-primary" style={{ padding: '20px', background: 'orange', color: 'maroon', fontSize: '14pt', fontWeight: '400', border: '1px solid orange' }}>Donate Golden Grace & Grandeur</Link>
					</div>


				</div>

			</div>




		</div>

	);
}

export default Home;